/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  DistributionManager,
  DistributionManagerInterface,
} from "../DistributionManager";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "emissionManager",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "IndexOverflow",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyEmissionManager",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "emission",
        type: "uint256",
      },
    ],
    name: "AssetConfigUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "AssetIndexUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newDistributionEnd",
        type: "uint256",
      },
    ],
    name: "DistributionEndUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "UserIndexUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "DISTRIBUTION_END",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EMISSION_MANAGER",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRECISION",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TEN_POW_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "assets",
    outputs: [
      {
        internalType: "uint104",
        name: "emissionPerSecond",
        type: "uint104",
      },
      {
        internalType: "uint104",
        name: "index",
        type: "uint104",
      },
      {
        internalType: "uint40",
        name: "lastUpdateTimestamp",
        type: "uint40",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
    ],
    name: "getAssetData",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getDistributionEnd",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
    ],
    name: "getUserAssetData",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "distributionEnd",
        type: "uint256",
      },
    ],
    name: "setDistributionEnd",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type DistributionManagerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: DistributionManagerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class DistributionManager__factory extends ContractFactory {
  constructor(...args: DistributionManagerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "DistributionManager";
  }

  deploy(
    emissionManager: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DistributionManager> {
    return super.deploy(
      emissionManager,
      overrides || {}
    ) as Promise<DistributionManager>;
  }
  getDeployTransaction(
    emissionManager: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(emissionManager, overrides || {});
  }
  attach(address: string): DistributionManager {
    return super.attach(address) as DistributionManager;
  }
  connect(signer: Signer): DistributionManager__factory {
    return super.connect(signer) as DistributionManager__factory;
  }
  static readonly contractName: "DistributionManager";
  public readonly contractName: "DistributionManager";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DistributionManagerInterface {
    return new utils.Interface(_abi) as DistributionManagerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DistributionManager {
    return new Contract(address, _abi, signerOrProvider) as DistributionManager;
  }
}
